var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"fields":_vm.fields,"show_header":false,"tbody_tr_class":_vm.row_class,"table_store":"pbx/phone-lists/form/table"},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var item = ref.item;
return [_c('table-control',{attrs:{"type":"trash"},on:{"click":function($event){return _vm.remove_item(item)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }